import {isMobile} from "../App";

export default function Gap() {
    if (isMobile) {
        return <div className="nk-gap-1"></div>
    } else {
        return <div className="nk-gap-4"></div>
    }
}